import styled from 'styled-components'

export const NoteItemList = styled.li`
  margin: 10px;
  border: 2px solid #aab8c8;
  padding: 10px;
  border-radius: 5px;
  width: 300px;
`
export const Title = styled.h1`
  font-family: 'Roboto';
  font-size: 25px;
  font-weight: 700;
  color: #334155;
`
export const Note = styled.p`
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: 900;
  color: #aab8c8;
`
